import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "13 11 14 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M15.75 12.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25V17.5h-4.25a.75.75 0 0 1-.75-.75V12.5zM22 13.56 24.44 16H22zm-9 .19A2.75 2.75 0 0 1 15.75 11h5.5a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v9.5A2.75 2.75 0 0 1 24.25 29h-8.5A2.75 2.75 0 0 1 13 26.25z",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgDocument);
export default Memo;
